import Utils from 'utils';

export const BANK_RECONCILIATION_ROLES = ['ROLE_ADMIN', 'ROLE_BANK_RECONCILIATION'];
export const BANK_RECONCILIATION_SETTINGS_ROLE = 'ROLE_ADMIN';

export const SYSTEM_ACTOR_DISPLAY_NAME = 'TMS (rapprochement bancaire)';
export const SYSTEM_ACTOR_USERNAME = 'tms-bot';

export const TRANSFER_FEE_TND = 3;
export const MAX_STATEMENT_SIZE = 10 * 1024 * 1024;

export const STATEMENT_PARSERS = ['biat', 'stb', 'poste'];
export const STATEMENT_PARSER_EXPORTS = {
    biat: 'Détails transactions (CSV)',
    stb: 'export.csv',
    poste: 'RLV_*.CSV',
};
export const STATEMENT_PARSERS_WITHOUT_ACCOUNT_NUMBER = ['stb'];

export const TRANSACTION_STATUSES = ['unmatched', 'suggested', 'flagged', 'matched', 'booked', 'ignored'];
export const OPEN_STATUSES = ['unmatched', 'suggested', 'flagged'];
export const REVIEW_STATUSES = ['suggested', 'flagged'];

export const CREDIT_KINDS = ['deposit', 'transfer_in', 'other_in'];
export const DEBIT_KINDS = ['bank_fee', 'interest', 'transfer_out', 'withdrawal', 'direct_debit', 'card', 'other_out'];
export const TRANSACTION_KINDS = [...CREDIT_KINDS, ...DEBIT_KINDS];
export const DIRECTIONS = ['credit', 'debit'];

export const KNOWN_FLAGS = [
    'amount_mismatch',
    'duplicate_reference',
    'wrong_bank',
    'no_account_configured',
    'invoice_settings_missing',
    'execution_failed',
];

export const STATUS_COLORS = {
    unmatched: 'default',
    suggested: 'orange',
    flagged: 'red',
    matched: 'green',
    booked: 'blue',
    ignored: 'default',
};

export const BANK_DATE_FORMAT = 'YYYY-MM-DD';
export const DISPLAY_DATE_FORMAT = 'DD/MM/YYYY';

export const formatTnd = amount => (amount === null || amount === undefined ? '—' : Utils.formatCurrency(amount, 'TND'));

export const isMatchable = line => line?.direction === 'credit' && (line.kind === 'deposit' || line.kind === 'transfer_in');
export const isTransfer = line => line?.kind === 'transfer_in';
export const isOpen = line => OPEN_STATUSES.includes(line?.status);

export const transferFee = line => (
    isTransfer(line) && line.expectedRequestAmount !== null && line.expectedRequestAmount !== undefined
        ? Math.round((line.amount - line.expectedRequestAmount) * 1000) / 1000
        : null
);

export const parseErrorDetails = details => {
    const text = String(details ?? '');
    const index = text.indexOf(': ');
    return index === -1
        ? { code: text, message: text }
        : { code: text.slice(0, index), message: text.slice(index + 2) };
};

export const getApiError = error => {
    const body = error?.response?.data;
    const details = body?.error?.details ?? body?.message ?? error?.message ?? '';
    return { status: error?.response?.status, ...parseErrorDetails(typeof details === 'string' ? details : JSON.stringify(details)) };
};

export const splitActor = matchedBy => {
    if (!matchedBy) return null;
    const index = matchedBy.indexOf('-');
    const username = index === -1 ? matchedBy : matchedBy.slice(index + 1);
    return { username, isSystem: username === SYSTEM_ACTOR_USERNAME };
};

export const getRequestOwner = creditRequest => (
    creditRequest?.shop?.name || creditRequest?.salesman?.name || null
);

export const toQueryParams = (params = {}) => Object.entries(params).reduce((result, [key, value]) => {
    if (value === undefined || value === null || value === '') return result;
    if (Array.isArray(value)) {
        if (value.length === 0) return result;
        result[key] = value.join(',');
        return result;
    }
    result[key] = value;
    return result;
}, {});

export const TOPUP_CONFIRMED_TYPE = 'topup_confirmed';

const TOPUP_CONFIRMED_QUERY_KEYS = ['get_credit', 'get_all_credit_request_transactions', 'get_all_transactions', 'get_credit_request_transaction_by_id'];

export const refreshAfterTopupConfirmed = queryClient => {
    TOPUP_CONFIRMED_QUERY_KEYS.forEach(key => queryClient.invalidateQueries({ queryKey: [key] }));
};
